import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';

export default function EnquiryTitle({ onCancel, title }) {
  return (
    <Stack alignItems='center' spacing={1.5} direction='row' sx={{ mb: 1.5 }}>
      {onCancel && (
        <IconButton
          onClick={onCancel}
          sx={{
            width: 18,
            height: 18,
            transform: 'rotate(90deg)',
            color: '#1E0040',
          }}>
          <ExpandCircleDownOutlinedIcon />
        </IconButton>
      )}
      <Typography
        variant='body1'
        sx={{ fontSize: 18, lineHeight: 1.22, fontWeight: 600 }}>
        {title}
      </Typography>
    </Stack>
  );
}
